import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
  CardFooter,
} from "./ui/card.tsx";
import { AlertTriangle } from "lucide-react";
import { GAME_FORMULAS } from "../lib/gameLogic.js";
import {
  GameState,
  Choice,
  Event,
  EventPopupProps,
  EventSystemProps,
} from "../lib/types.ts";
import "./EventSystem.css";

// const EVENTS: Event[] = [
//   {
//     id: "algorithm_breakthrough",
//     trigger: {
//       type: "algorithmLevel",
//       condition: (state) => state.algorithmLevel === 4,
//       hasTriggered: false,
//     },
//     title: "Technology Breakthrough",
//     description:
//       "A new AI tool offers to substantially improve your algorithm's efficiency, but at a cost.",
//     choices: [
//       {
//         text: (state: GameState) =>
//           `Adopt the new technology ($${Math.max(
//             state.money * 0.25,
//             500
//           ).toFixed(2)})`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.25, 500),
//           maxAlgorithmLevel: state.maxAlgorithmLevel + 2,
//         }),
//       },
//       {
//         text: (state: GameState) =>
//           "Pass on the offer and maintain current operations",
//         effect: (state) => state,
//       },
//     ],
//   },
//   {
//     id: "algorithm_bias",
//     trigger: {
//       type: "algorithmLevel",
//       condition: (state) => state.algorithmLevel === 6,
//       hasTriggered: false,
//     },
//     title: "Algorithm Bias Outcry",
//     description:
//       "Reports surface that your algorithm unfairly favors certain types of content, creating bias.",
//     choices: [
//       {
//         text: (state) =>
//           `Invest in retraining the algorithm (+10 Reputation, -$${Math.max(
//             state.money * 0.15,
//             300
//           ).toFixed(2)})`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.15, 300),
//           reputation: state.reputation + 10,
//           algorithmLevel: state.algorithmLevel - 1,
//         }),
//       },
//       {
//         text: (state) => "Ignore the issue and face user backlash",
//         effect: (state) => ({
//           ...state,
//           userCount: Math.max(state.userCount * 0.85, 0),
//         }),
//       },
//     ],
//   },
//   {
//     id: "privacy_scandal",
//     trigger: {
//       type: "adPersonalization",
//       condition: (state) => state.adPersonalization > 30,
//       hasTriggered: false,
//     },
//     title: "Privacy Scandal",
//     description:
//       "A whistleblower leaks that your platform collects extensive user data without proper consent. This creates a public outcry, and you must act quickly.",
//     choices: [
//       {
//         text: (state) =>
//           `Pay a fine to regulators (-$${Math.max(
//             state.money * 0.2,
//             400
//           ).toFixed(2)}, -5 Reputation)`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.2, 400),
//           reputation: state.reputation - 5,
//         }),
//       },
//       {
//         text: (state) =>
//           "Accept user loss and reduce personalization (-5% Ad Personalization)",
//         effect: (state) => ({
//           ...state,
//           userCount: Math.max(0, state.userCount * 0.9),
//           adPersonalization: Math.max(0, state.adPersonalization - 5),
//         }),
//       },
//     ],
//   },
//   {
//     id: "pandemic_boost",
//     trigger: {
//       type: "userCount",
//       condition: (state) => state.userCount > 5000,
//       hasTriggered: false,
//     },
//     title: "Pandemic Boost",
//     description:
//       "A global pandemic increases screen time, leading to a surge in social media use.",
//     choices: [
//       {
//         text: (state) =>
//           `Scale servers and improve infrastructure (-$${Math.max(
//             state.money * 0.3,
//             600
//           ).toFixed(2)})`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.3, 600),
//           userCount: state.userCount * 1.4,
//         }),
//       },
//       {
//         text: (state) => "Maintain current infrastructure (-5 Reputation)",
//         effect: (state) => ({
//           ...state,
//           userCount: state.userCount * 1.15,
//           reputation: state.reputation - 5,
//         }),
//       },
//     ],
//   },
//   {
//     id: "competitor_surge",
//     trigger: {
//       type: "userCount",
//       condition: (state) => state.userCount > 10000,
//       hasTriggered: false,
//     },
//     title: "Competitor Surge",
//     description:
//       "A new competitor with innovative features is rapidly gaining popularity. Users are tempted to switch platforms.",
//     choices: [
//       {
//         text: (state) =>
//           `Invest in marketing campaigns (-$${Math.max(
//             state.money * 0.25,
//             500
//           ).toFixed(2)})`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.25, 500),
//           userCount: state.userCount * 1.1,
//         }),
//       },
//       {
//         text: (state) => "Do nothing",
//         effect: (state) => ({
//           ...state,
//           userCount: Math.max(0, state.userCount * 0.8),
//         }),
//       },
//     ],
//   },
//   {
//     id: "cybersecurity_breach",
//     trigger: {
//       type: "userCount",
//       condition: (state) => state.userCount > 150000,
//       hasTriggered: false,
//     },
//     title: "Cybersecurity Breach",
//     description: "A major data breach exposes sensitive user information.",
//     choices: [
//       {
//         text: (state) =>
//           `Upgrade security immediately (+5 Reputation, -$${Math.max(
//             state.money * 0.4,
//             800
//           ).toFixed(2)}, -10% Ad Personalization)`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.4, 800),
//           reputation: state.reputation + 5,
//           adPersonalization: Math.max(0, state.adPersonalization - 10),
//         }),
//       },
//       {
//         text: (state) => "Issue public statement only (-10 Reputation)",
//         effect: (state) => ({
//           ...state,
//           reputation: state.reputation - 10,
//           userCount: Math.max(0, state.userCount * 0.7),
//         }),
//       },
//     ],
//   },
//   {
//     id: "government_regulation",
//     trigger: {
//       type: "revenue",
//       condition: (state) => state.money > 500000,
//       hasTriggered: false,
//     },
//     title: "Government Regulation",
//     description:
//       "A new government policy caps the number of ads per user to combat digital fatigue.",
//     choices: [
//       {
//         text: (state) => "Comply with regulations (-30% Ad Frequency)",
//         effect: (state) => ({
//           ...state,
//           adFrequency: Math.max(0, state.adFrequency - 30),
//         }),
//       },
//       {
//         text: (state) =>
//           `Lobby against the regulation (-$${Math.max(
//             state.money * 0.35,
//             700
//           ).toFixed(2)})`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.35, 700),
//         }),
//       },
//     ],
//   },
//   {
//     id: "rising_server_costs",
//     trigger: {
//       type: "overheadCost",
//       condition: (state) =>
//         GAME_FORMULAS.calculateOverheadCost(
//           state.userCount,
//           state.engagement,
//           state.algorithmLevel,
//           state.maxAlgorithmLevel
//         ) > 50000,
//       hasTriggered: false,
//     },
//     title: "Rising Server Costs",
//     description:
//       "Your platform's server costs are escalating due to a surge in user base and the need for better infrastructure.",
//     choices: [
//       {
//         text: (state) =>
//           `Invest in cloud solutions (-$${Math.max(
//             state.money * 0.1,
//             200
//           ).toFixed(2)})`,
//         effect: (state) => ({
//           ...state,
//           money: state.money * 1.1, // This is a gain, so no minimum needed
//         }),
//       },
//       {
//         text: (state) => "Neglect the issue",
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.15, 300),
//         }),
//       },
//     ],
//   },
//   {
//     id: "legal_fees",
//     trigger: {
//       type: "overheadCost",
//       condition: (state) =>
//         GAME_FORMULAS.calculateOverheadCost(
//           state.userCount,
//           state.engagement,
//           state.algorithmLevel,
//           state.maxAlgorithmLevel
//         ) > 100000,
//       hasTriggered: false,
//     },
//     title: "Unexpected Legal Fees",
//     description:
//       "Your platform faces a lawsuit over privacy violations, leading to significant legal fees and increased overhead costs.",
//     choices: [
//       {
//         text: (state) =>
//           `Settle the lawsuit (-$${Math.max(state.money * 0.3, 600).toFixed(
//             2
//           )})`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.3, 600),
//         }),
//       },
//       {
//         text: (state) =>
//           `Fight the lawsuit (-$${Math.max(state.money * 0.5, 1000).toFixed(
//             2
//           )}, -20% Users)`,
//         effect: (state) => ({
//           ...state,
//           money: state.money - Math.max(state.money * 0.5, 1000),
//           userCount: Math.max(0, state.userCount * 0.8),
//         }),
//       },
//     ],
//   },
// ];

const EVENTS: Event[] = [
  {
    id: "algorithm_breakthrough",
    trigger: {
      type: "algorithmLevel",
      condition: (state) => state.algorithmLevel === 4,
      hasTriggered: false,
    },
    title: "Technology Breakthrough",
    description:
      "A new AI tool offers to substantially improve your algorithm's efficiency, but at a cost.",
    choices: [
      {
        text: (state: GameState) =>
          `Adopt the new technology\nCost: $${Math.max(
            state.money * 0.25,
            500
          ).toLocaleString()}\nBenefit: Unlock 2 new algorithm levels`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.25, 500),
          maxAlgorithmLevel: state.maxAlgorithmLevel + 2,
        }),
      },
      {
        text: (state: GameState) =>
          "Keep current technology\nCost: None\nBenefit: Save money",
        effect: (state) => state,
      },
    ],
  },
  {
    id: "algorithm_bias",
    trigger: {
      type: "algorithmLevel",
      condition: (state) => state.algorithmLevel === 7,
      hasTriggered: false,
    },
    title: "Algorithm Bias Outcry",
    description:
      "Reports surface that your algorithm unfairly favors certain types of content, creating bias.",
    choices: [
      {
        text: (state) =>
          `Retrain the algorithm\nCost: $${Math.max(
            state.money * 0.15,
            300
          ).toLocaleString()}\nEffect: Algorithm level reduced by 1\nBenefit: Platform reputation increased`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.15, 300),
          reputation: state.reputation + 10,
          algorithmLevel: state.algorithmLevel - 1,
        }),
      },
      {
        text: (state) =>
          "Ignore the issue\nCost: Lose 15% of users\nBenefit: No immediate financial cost",
        effect: (state) => ({
          ...state,
          userCount: Math.max(state.userCount * 0.85, 0),
        }),
      },
    ],
  },
  {
    id: "privacy_scandal",
    trigger: {
      type: "adPersonalization",
      condition: (state) => state.adPersonalization > 30,
      hasTriggered: false,
    },
    title: "Privacy Scandal",
    description:
      "A whistleblower leaks that your platform collects extensive user data without proper consent. This creates a public outcry, and you must act quickly.",
    choices: [
      {
        text: (state) =>
          `Pay the regulators\nCost: $${Math.max(
            state.money * 0.2,
            400
          ).toLocaleString()}\nEffect: Small reputation damage\nBenefit: Keep current users`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.2, 400),
          reputation: state.reputation - 5,
        }),
      },
      {
        text: (state) =>
          "Reduce data collection\nCost: Lose 10% of users\nEffect: Ad personalization reduced by 5%\nBenefit: No financial penalty",
        effect: (state) => ({
          ...state,
          userCount: Math.max(0, state.userCount * 0.9),
          adPersonalization: Math.max(0, state.adPersonalization - 5),
        }),
      },
    ],
  },
  {
    id: "pandemic_boost",
    trigger: {
      type: "userCount",
      condition: (state) => state.userCount > 2000,
      hasTriggered: false,
    },
    title: "Pandemic Boost",
    description:
      "A global pandemic increases screen time, leading to a surge in social media use.",
    choices: [
      {
        text: (state) =>
          `Upgrade infrastructure\nCost: $${Math.max(
            state.money * 0.3,
            600
          ).toLocaleString()}\nBenefit: User base increases by 40%`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.3, 600),
          userCount: state.userCount * 1.4,
        }),
      },
      {
        text: (state) =>
          "Keep current infrastructure\nCost: Platform reputation damaged\nBenefit: User base still increases by 15%",
        effect: (state) => ({
          ...state,
          userCount: state.userCount * 1.15,
          reputation: state.reputation - 5,
        }),
      },
    ],
  },
  {
    id: "competitor_surge",
    trigger: {
      type: "userCount",
      condition: (state) => state.userCount > 10000,
      hasTriggered: false,
    },
    title: "Competitor Surge",
    description:
      "A new competitor with innovative features is rapidly gaining popularity. Users are tempted to switch platforms.",
    choices: [
      {
        text: (state) =>
          `Launch marketing campaign\nCost: $${Math.max(
            state.money * 0.25,
            500
          ).toLocaleString()}\nBenefit: User base increases by 10%`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.25, 500),
          userCount: state.userCount * 1.1,
        }),
      },
      {
        text: (state) =>
          "Take no action\nCost: Lose 20% of users\nBenefit: No financial cost",
        effect: (state) => ({
          ...state,
          userCount: Math.max(0, state.userCount * 0.8),
        }),
      },
    ],
  },
  {
    id: "cybersecurity_breach",
    trigger: {
      type: "userCount",
      condition: (state) => state.userCount > 150000,
      hasTriggered: false,
    },
    title: "Cybersecurity Breach",
    description: "A major data breach exposes sensitive user information.",
    choices: [
      {
        text: (state) =>
          `Upgrade security systems\nCost: $${Math.max(
            state.money * 0.4,
            800
          ).toLocaleString()}\nEffect: Ad personalization reduced by 10%\nBenefit: Reputation increases`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.4, 800),
          reputation: state.reputation + 5,
          adPersonalization: Math.max(0, state.adPersonalization - 10),
        }),
      },
      {
        text: (state) =>
          "Issue public statement\nCost: Lose 30% of users\nEffect: Major reputation damage\nBenefit: No financial cost",
        effect: (state) => ({
          ...state,
          reputation: state.reputation - 10,
          userCount: Math.max(0, state.userCount * 0.7),
        }),
      },
    ],
  },
  {
    id: "government_regulation",
    trigger: {
      type: "revenue",
      condition: (state) => state.money > 500000,
      hasTriggered: false,
    },
    title: "Government Regulation",
    description:
      "A new government policy caps the number of ads per user to combat digital fatigue.",
    choices: [
      {
        text: (state) =>
          "Comply with regulations\nCost: Ad frequency reduced by 30%\nBenefit: Maintain good standing with regulators",
        effect: (state) => ({
          ...state,
          adFrequency: Math.max(0, state.adFrequency - 30),
        }),
      },
      {
        text: (state) =>
          `Fight the regulation\nCost: $${Math.max(
            state.money * 0.35,
            700
          ).toLocaleString()}\nBenefit: Maintain current ad frequency`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.35, 700),
        }),
      },
    ],
  },
  {
    id: "rising_server_costs",
    trigger: {
      type: "overheadCost",
      condition: (state) =>
        GAME_FORMULAS.calculateOverheadCost(
          state.userCount,
          state.engagement,
          state.algorithmLevel,
          state.maxAlgorithmLevel
        ) > 50000,
      hasTriggered: false,
    },
    title: "Rising Server Costs",
    description:
      "Your platform's server costs are escalating due to a surge in user base and the need for better infrastructure.",
    choices: [
      {
        text: (state) =>
          `Invest in cloud solutions\nCost: $${Math.max(
            state.money * 0.1,
            200
          ).toLocaleString()}\nBenefit: Revenue increases by 10%`,
        effect: (state) => ({
          ...state,
          money: state.money * 1.1,
        }),
      },
      {
        text: (state) =>
          `Ignore infrastructure needs\nCost: $${Math.max(
            state.money * 0.15,
            300
          ).toLocaleString()} in penalties\nBenefit: None`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.15, 300),
        }),
      },
    ],
  },
  {
    id: "legal_fees",
    trigger: {
      type: "overheadCost",
      condition: (state) =>
        GAME_FORMULAS.calculateOverheadCost(
          state.userCount,
          state.engagement,
          state.algorithmLevel,
          state.maxAlgorithmLevel
        ) > 100000,
      hasTriggered: false,
    },
    title: "Unexpected Legal Fees",
    description:
      "Your platform faces a lawsuit over privacy violations, leading to significant legal fees and increased overhead costs.",
    choices: [
      {
        text: (state) =>
          `Settle the lawsuit\nCost: $${Math.max(
            state.money * 0.3,
            600
          ).toLocaleString()}\nBenefit: Issue resolved quickly`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.3, 600),
        }),
      },
      {
        text: (state) =>
          `Fight in court\nCost: $${Math.max(
            state.money * 0.5,
            1000
          ).toLocaleString()}\nEffect: Lose 20% of users\nBenefit: Potential to set favorable legal precedent`,
        effect: (state) => ({
          ...state,
          money: state.money - Math.max(state.money * 0.5, 1000),
          userCount: Math.max(0, state.userCount * 0.8),
        }),
      },
    ],
  },
];

const EventPopup: React.FC<EventPopupProps> = ({ event, onChoice, state }) => {
  if (!event) return null;

  // Prevent clicks on the overlay from bubbling
  const handleOverlayClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className="event-popup-overlay">
      <div className="event-popup" onClick={handleOverlayClick}>
        <Card>
          <CardHeader>
            <div className="event-header">
              <AlertTriangle className="event-icon" />
              <CardTitle>{event.title}</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="event-description">{event.description}</p>
          </CardContent>
          <CardFooter>
            <div className="event-choices">
              {event.choices.map((choice, index) => (
                <button
                  key={index}
                  className="choice-button"
                  onClick={() => onChoice(choice)}
                >
                  {choice.text(state)}
                </button>
              ))}
            </div>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

const EventSystem: React.FC<EventSystemProps> = ({
  gameState,
  setGameState,
  setIsPaused,
}) => {
  const [currentEvent, setCurrentEvent] = useState<Event | null>(null);
  const [triggeredEvents, setTriggeredEvents] = useState<Set<string>>(
    new Set()
  );

  // Use useEffect to handle pause state when event appears/disappears
  useEffect(() => {
    if (currentEvent) {
      setIsPaused(true);
    }
  }, [currentEvent, setIsPaused]);

  // Separate useEffect for checking new events
  useEffect(() => {
    if (currentEvent) return;

    const availableEvent = EVENTS.find(
      (event) =>
        !triggeredEvents.has(event.id) && event.trigger.condition(gameState)
    );

    if (availableEvent) {
      setCurrentEvent(availableEvent);
    }
  }, [gameState, currentEvent, triggeredEvents]);

  const handleChoice = (choice: Choice) => {
    const newState = choice.effect(gameState);
    try {
      setGameState(newState);
    } catch (error) {
      console.error("Error updating game state:", error);
    }
    setTriggeredEvents((prev) => new Set([...prev, currentEvent!.id]));
    setCurrentEvent(null);
    setIsPaused(false);
  };

  return currentEvent ? (
    <EventPopup
      event={currentEvent}
      onChoice={handleChoice}
      state={gameState}
    />
  ) : null;
};

export default EventSystem;
